module.exports = __webpack_public_path__ + "img/s.ba082b73.webp";